import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createFilingsQueries(client: StoxlyClient) {
  return createQueryKeys('filings', {
    // ['filings', 'events', { query }] — a company's current-report feed
    events: (query: Query<'filingsGetEvents'>) => ({
      queryKey: [{ query }],
      queryFn: ({ signal }) => client.filingsGetEvents({ queries: query, signal }),
    }),
  });
}
